// extracted by mini-css-extract-plugin
export default {"container":"Cancelled_container__hnUbp","time":"Cancelled_time__1CbgJ","name":"Cancelled_name__bcdNk","spin":"Cancelled_spin__4Sr9T"};